import { render, staticRenderFns } from "./TopInfoBar.vue?vue&type=template&id=5ab986c8&scoped=true&"
import script from "./TopInfoBar.vue?vue&type=script&lang=js&"
export * from "./TopInfoBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab986c8",
  null
  
)

export default component.exports